<template>
  <div class="padding-10px">
    <el-card class="box-card" shadow="none" style="min-height: 500px;">
      <div slot="header" class="clearfix" style="display: flex; flex-direction: column">
        <el-row>
          <el-col :span="5" :lg="4" :md="5">
            <div>
              <el-input placeholder="请输入搜索关键字" v-model="world" style="width: 180px;" size="medium" clearable>
              </el-input>
            </div>
          </el-col>
          <el-col :span="10" :lg="9" :md="9">
            <div>
              <el-date-picker v-model="createTime" type="datetimerange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" size="medium" :editable="true" :clearable="true">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="5" :lg="7" :md="5">
            <div>
              <el-button type="primary" size="medium" icon="el-icon-search" @click="searchChannel">搜索</el-button>
            </div>
          </el-col>
          <el-col :span="4" :lg="4" :md="5">
            <el-button type="success" size="medium" @click="openDialog('add', null)"
              v-if="checkButtonPermission('channel:manage:add')">新增渠道</el-button>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-table :data="tableData" border style="width: 100%" max-height="400">
          <el-table-column prop="channelName" label="渠道名" width="120"></el-table-column>
          <el-table-column prop="guideIntegral" label="导购积分/礼品" width="120"></el-table-column>
          <el-table-column prop="carLoanIntegral" label="车贷积分/礼品" width="120"></el-table-column>
          <el-table-column prop="posterRegister" label="注册海报" width="80">
            <template slot-scope="scope" v-if="undefined != scope.row.posterRegister && '' != scope.row.posterRegister">
              <img :src="scope.row.posterRegister" width="32" height="32">
            </template>
          </el-table-column>
          <el-table-column prop="posterMiniProgram" label="公众号海报" width="90">
            <template slot-scope="scope"
              v-if="undefined != scope.row.posterMiniProgram && '' != scope.row.posterMiniProgram">
              <img :src="scope.row.posterMiniProgram" width="32" height="32">
            </template>
          </el-table-column>
          <el-table-column prop="registerH5Link" label="注册链接" width="80" :show-overflow-tooltip="true">
            <template slot-scope="scope" v-if="undefined != scope.row.registerH5Link && '' != scope.row.registerH5Link">
              <el-tooltip class="item span_hover" effect="light" :content="scope.row.registerH5Link" placement="top">
                <span class="span_hide registerH5Link" @click="copyLink(scope.row)" data-clipboard-action="copy"
                  :data-clipboard-text="scope.row.registerH5Link" v-html="scope.row.registerH5Link">
                </span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="时间" width="170"></el-table-column>
          <el-table-column prop="registerCount" label="注册人数" width="90"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="openDialog('edit', scope.row)" type="success" size="mini"
                v-if="checkButtonPermission('channel:manage:edit')">
                编辑
              </el-button>
              <el-button v-if="scope.row.channelStatus == 0" @click="channelOperation(scope.row.channelId, 1)"
                type="success" size="mini">启用
              </el-button>
              <el-button v-else-if="scope.row.channelStatus == 1" @click="channelOperation(scope.row.channelId, 0)"
                type="danger" size="mini">禁用
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 18px 0px; float: right;">
          <el-pagination background @current-change="currentPageChange" @size-change="pageSizeChange"
            :current-page="currentPage" :page-sizes="[5, 10, 20, 50, 100]" :page-size="pageSize" :page-count="totalPage"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>
    <el-dialog :title="dialogTitle + '渠道'" :visible.sync="addChannelDialogVisible" :modal="false"
      :close-on-click-modal="false" @close="resetForm('channelForm')">
      <el-form :model="channelForm" ref="channelForm" :rules="channelRules" label-width="120px" size="medium"
        style="padding: 0 10%;">
        <el-form-item label="渠道名称" prop="channelName">
          <el-input v-model="channelForm.channelName" clearable></el-input>
        </el-form-item>
        <el-form-item label="渠道类型" prop="channelCategory">
          <el-select v-model="channelCategorySelect" placeholder="请选择渠道类型" @change="channelCategoryChange">
            <el-option v-for="category in channelCategory" :label="category.label" :value="category.value"
              :key="category.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="'导购' + prizeName" prop="guideIntegral">
          <el-input v-model="channelForm.guideIntegral" clearable></el-input>
        </el-form-item>
        <el-form-item :label="'车贷' + prizeName" prop="carLoanIntegral">
          <el-input v-model="channelForm.carLoanIntegral" clearable></el-input>
        </el-form-item>
        <el-form-item label="海报图片" prop="posterImage">
          <el-upload :class="{ hide: hidePosterImage }" :limit="posterLimit" :file-list="fileList"
            :action="this.env.env.uploadUrl" list-type="picture-card" :on-success="uploadPosterSuccess"
            :on-preview="uploadPreviewHandler" :on-remove="uploadRemoveHandler">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item size="large">
          <el-button
            @click="addChannelDialogVisible = false">&nbsp;&nbsp;&nbsp;取&nbsp;&nbsp;消&nbsp;&nbsp;&nbsp;</el-button>
          <el-button type="primary"
            @click="submitChannelForm('channelForm')">&nbsp;&nbsp;&nbsp;确&nbsp;&nbsp;定&nbsp;&nbsp;&nbsp;</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Clipboard from 'clipboard';
import { reqCode, dialogAction } from '@/common/const';
export default {
  name: "channelList",
  data() {
    return {
      hidePosterImage: false,
      hideCarLoanPoster: false,
      hideGuidePoster: false,
      posterLimit: 1,
      channelCategorySelect: '推手渠道',
      channelCategoryVal: '1',
      channelCategory: [
        {
          label: '推手渠道',
          value: '1'
        },
        {
          label: '普通渠道',
          value: '0'
        }
      ],
      dialogTitle: '新增',
      dialogOperation: 'add',
      fileList: [],
      tableData: [
        {
          setRegisterH5Link: '',
          channelName: "渠道1",
          guideIntegral: "导购积分",
          carLoanIntegral: "车贷积分",
          createTime: "2020-03-05 21:00:00"
        }
      ],
      currentPage: 1,
      pageSize: 20,
      totalPage: 100,
      total: 100000,
      world: '',
      createTime: [],
      addChannelDialogVisible: false,
      channelForm: {
        carLoanIntegral: '',
        channelCategory: '1',
        channelName: '',
        guideIntegral: '',
      },
      channelRules: {
        channelName: [{ required: true, message: '导购积分不能为空', trigger: 'blur' }],
        guideIntegral: [{ required: true, message: '渠道名称不能为空', trigger: 'blur' }],
        carLoanIntegral: [{ required: true, message: '车贷积分不能为空', trigger: 'blur' }],
      },
      prizeName: '积分',
    }
  },
  created() {
    this.searchChannel();
  },
  methods: {
    copyLink(data) {
      let clipboard = new Clipboard('.registerH5Link', {
        text: function () {
          return data.registerH5Link;
        }
      })
      clipboard.on('success', e => {
        this.$message({ message: '复制成功', showClose: true, type: 'success' });
        // 释放内存
        clipboard.destroy();
      })
      clipboard.on('error', e => {
        this.$message({ message: '复制失败,请手动复制', showClose: true, type: 'error' });
        clipboard.destroy()
      })
    },
    openDialog(dialogOperation, data) {
      this.hidePosterImage = false;
      this.dialogOperation = dialogOperation;
      if (dialogAction.ADD == dialogOperation) {
        this.dialogTitle = '新增';
        this.channelCategoryVal = '1';
      } else if (dialogAction.EDIT == dialogOperation) {
        this.dialogTitle = '编辑';
        let temp = {};
        Object.assign(temp, data);
        console.log(temp);
        this.channelForm = temp;

        // 绑定图片
        let posterRegister = temp.posterRegister;
        if (posterRegister) {
          let object = new Object();
          object.url = posterRegister;
          this.fileList.push(object);

          this.hidePosterImage = true;
        }

        let channelCategory = temp.channelCategory;
        // 绑定渠道
        if (channelCategory == 0) {
          this.channelCategorySelect = '普通渠道';
          this.channelCategoryVal = '0';
        } else if (channelCategory == 1) {
          this.channelCategorySelect = '推手渠道';
          this.channelCategoryVal = '1';
        }

      }
      this.addChannelDialogVisible = true;
    },
    uploadPosterSuccess(resp, file, list) {
      this.hidePosterImage = list.length >= this.posterLimit;
      if (reqCode.SUCCESS == resp.code) {
        this.channelForm.posterImage = resp.data;
      } else {
        this.$message({
          message: '上传文件失败：' + resp.message,
          type: 'error'
        });
      }
    },
    currentPageChange(val) {
      this.currentPage = val;
      this.searchChannel();
    },
    pageSizeChange(val) {
      this.pageSize = val;
      this.searchChannel();
    },
    linkTo(url) {
      this.$router.push({ path: url });
    },
    submitChannelForm(formName) {
      if (dialogAction.ADD == this.dialogOperation) {
        this.addChannel(formName);
      } else if (dialogAction.EDIT == this.dialogOperation) {
        console.log('edit');
        this.updateChannel(formName);
      }
    },
    addChannel(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.post('/api/channel-service/channel/add', this.channelForm, {
            headers: {
              accessToken: sessionStorage.getItem('accessToken')
            }
          }).then(resp => {
            console.log(resp);
            let data = resp.data;
            let code = data.code;
            if (data.code === "success") {
              this.$message({
                message: '成功添加一条渠道信息',
                type: 'success'
              });
              this.addChannelDialogVisible = false;
              this.resetForm();
              this.searchChannel();
            } else {
              this.$alert(data.message, '温馨提示', {
                confirmButtonText: '确定'
              });
            }

          }).catch(response => {
            this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
              confirmButtonText: '确定'
            });
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    updateChannel(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.post('/api/channel-service/channel/update', this.channelForm, {
            headers: {
              accessToken: sessionStorage.getItem('accessToken')
            }
          }).then(resp => {
            let data = resp.data;
            if (reqCode.SUCCESS == data.code) {
              this.$message({
                message: '编辑渠道成功',
                type: 'success'
              });
              this.addChannelDialogVisible = false;
              this.resetForm();
              this.searchChannel();
            } else {
              this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + data.message, '温馨提示', {
                confirmButtonText: '确定'
              });
            }
          }).catch(response => {
            this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
              confirmButtonText: '确定'
            });
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    searchChannel() {
      let reqParam = {
        currentPage: this.currentPage,
        size: this.pageSize,
        startCreateTime: this.createTime[0],
        endCreateTime: this.createTime[1],
        world: this.world,
      };
      this.$http.post('/api/channel-service/channel/search', reqParam, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        console.log(resp);
        let pageInfo = resp.data.pageInfo;
        this.tableData = pageInfo.list;
        this.pageSize = pageInfo.pageSize;
        this.total = pageInfo.total;
      }).catch(e => {
        if (response.response.data == 401) {
          this.$router.push({ path: '/login' });
        } else {
          this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
            confirmButtonText: '确定'
          });
        }
      })
    },
    resetForm(formName) {
      this.$nextTick(() => {
        this.createTime = [];
        this.channelForm = {};
        this.channelCategoryVal = '1',
          this.fileList = [];
        this.$refs[formName].resetFields();
      })
    },
    channelCategoryChange(val) {
      if (val == 0) {
        this.prizeName = '礼品';
        this.channelCategorySelect = '普通渠道';
        this.channelCategoryVal = '0';
      } else if (val == 1) {
        this.prizeName = '积分';
        this.channelCategorySelect = '推手渠道';
        this.channelCategoryVal = '1';
      }
      this.channelForm.channelCategory = this.channelCategoryVal;
      console.log(this.channelCategoryVal + ': ', this.channelCategorySelect);
    },
    channelOperation(channelId, channelStatus) {
      let reqParam = {
        channelId: channelId,
        channelStatus: channelStatus,
      };
      this.$http.post('/api/channel-service/channel/operation', reqParam, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        this.$message({
          message: '操作成功',
          type: 'success'
        });
        this.searchChannel();
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    uploadRemoveHandler(file, list) {
      this.hidePosterImage = list.length >= this.posterLimit;
    },
    uploadPreviewHandler(file) {
      this.channelForm.posterRegister = file.url;
    },
    checkButtonPermission(perms) {
      let menuPermsList = sessionStorage.getItem("menuPermsList");
      if (menuPermsList.indexOf(perms) != -1) {
        return true
      } else {
        return false;
      }
    }
  },
  watch: {
    createTime(newCeateTime, oldCeateTime) {
      if (null == newCeateTime || undefined == newCeateTime) {
        this.createTime = [];
      }
    }
  }
}
</script>

<style>
.span_hide {
  overflow: hidden;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  height: 24px;
  display: block;
}

.span_hover:hover {
  cursor: pointer;
}

.hide .el-upload--picture-card {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/channel/channelList.vue